<template>
    <div v-if="registration">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-11">
                    <header-card
                        :registration="registration"
                        :simulation="simulation"
                        :status-data="statusData"
                        :status-colors="statusColors"
                        :sync="sync"
                    >
                    </header-card>
                    <log-steps
                        current="log"
                        :registration="registration"
                        :simulation="simulation"
                    ></log-steps>
                </div>
                <div class="col-1">
                </div>
            </div>
            <log
                :registration="registration"
                :simulation="simulation"
                :log="log"
                :types="types"
                :competencies="competencies"
                :stats="stats"
                @reload-stats="loadStats"
            ></log>
        </div>
    </div>
</template>

<script>
    import HeaderCard from './logs/Header';
    import Log from './logs/Log';
    import LogSteps from './logs/LogSteps';

    export default {

        components: {
            HeaderCard, Log, LogSteps
        },

        data() {
            return {
                log: null,
                registration: null,
                simulation: null,
                types: null,
                competencies: null,
                stats: null,
                statusData: [],
                statusColors: {},
                sync: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.logs'),
                        route: '/socrates/ui/dashboard/logs'
                    },
                    {
                        name: this.registration.cohort.name + ' / ' + this.registration.degree.name,
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/logs/registrations/' + to.params.registrationId + '/simulations/' + to.params.simulationId + '/log')
            .then(resp => {
                next(vm => {
                    vm.log = resp.data.data
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.types = resp.data.included.types
                    vm.competencies = resp.data.included.competencies
                    vm.statusData = resp.data.included.status_data
                    vm.statusColors = resp.data.included.status_colors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.loadStats()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    // This may happen if the connection fails with an online session.
                    next({ name: 'home' });
                }
            });
        },

        methods: {

            loadStats() {
                axios.get('/socrates/api/front/dashboard/data/logs/registrations/' + this.registration.id + '/simulations/' + this.simulation.id + '/stats')
                .then(resp => {
                    this.$loader.hide()
                    this.stats = resp.data.data
                    this.sync = resp.data.included && resp.data.included.sync
                        ? resp.data.included.sync
                        : null
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },
        }
    }
</script>
